import React from 'react';
import Footer from '../../layout/footers/footer';
import Header from '../../layout/headers/header';
import MeuPerfilArea from './meu-perfil-area';

const index = () => {
  return (
    <>
      {/* header start */}
      <Header header_shadow={true} />
      {/* header end */}

      {/* sign in area start */}
      <MeuPerfilArea />
      {/* sign in area end */}

      {/* footer area start */}
      <Footer pt="pt-90" />
      {/* footer area end */}
    </>
  );
};

export default index;